// Module
var code = "<workshop-type-selection></workshop-type-selection>";
// Exports
module.exports = code;